import styled from "styled-components";
import { Colors, Styleguide, theme } from "../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${theme(Colors.white, Colors.gray[500])};
  gap: 24px;
  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    gap: 48px;
  }
`;

export const Loading = styled.div`
  width: 4rem;
  height: 4rem;
  animation: spin 2s linear infinite;
  margin: auto 0px;
  color: ${theme(Colors.blue[100], Colors.white)};

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ContentImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    gap: 54px;
  }
`;

export const Image = styled.img`
  width: 88px;
  height: auto;
`;
